import { render, staticRenderFns } from "./ChartsBar.vue?vue&type=template&id=5813b510&"
import script from "./ChartsBar.vue?vue&type=script&lang=js&"
export * from "./ChartsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports